export default {
  agentGroup: [
    { id: "NEXTPAY_COMPANY", text: "Doanh nghiệp" },
    { id: "NEXTPAY_INDIVIDUAL", text: "Cá nhân" },
  ],
  agentType: [{ id: "NEXTPAY", text: "Nextpay" }],
  merchantStatus: [
    { id: '0', text: 'Tất cả'},
    { id: "NEW", text: "Mới tạo" },
    { id: "CONSULTING", text: "Đang tư vấn" },
    { id: "SUCCESS", text: "Thành công" },
    { id: "NO_CARE", text: "Chưa quan tâm" },
    { id: "VERIFIED", text: "Có quan tâm" },
    { id: "USED_SERVICE", text: "Đã sử dụng dịch vụ" },
    { id: "WRONG", text: "Thông tin sai" },
    { id: "DUPLICATE", text: "Trùng thông tin" },
    { id: "POTENTIAL", text: "Merchant tiềm năng" },
    { id: "EXPIRED_SUPPORT", text: "Quá thời gian chăm sóc" },
    { id: "DELETED", text: "Đã xóa" },
    { id: "MERCHANT", text: "Merchant" },
  ],
  statusDevices: [
    { id: "AVAILABILITY", text: "Chờ kích hoạt", bgColor: "badge-info" },
    { id: "WAIT_TRANSFER", text: "Chờ chuyển", bgColor: "badge-primary" },
    { id: "MOVING", text: "Đang chuyển", bgColor: "badge-warning" },
    { id: "EXPORTED", text: "Đã kích hoạt", bgColor: "badge-success" },
    { id: "WAITING_EXPORT", text: "Đã KH, chờ thanh toán", bgColor: "badge-success" },
  ],
  statusWarehouse: [
    { id: "NEW", text: "Mới tạo" },
    { id: "APPROVED", text: "Đã duyệt" },
    { id: "REJECTED", text: "Từ chối duyệt" },
    { id: "MOVING", text: "Đang chuyển" },
    { id: "REJECT_IMPORT", text: "Từ chối nhập" },
    { id: "SUCCESS", text: "Thành công" },
    { id: "CANCELLED", text: "Đã huỷ" },
    { id: "NOT_RECEIVED", text: "Không nhận được hàng" }
  ],
  typeBill: [
    { id: "IMPORT", text: "Nhập kho" },
    { id: "EXPORT", text: "Xuất kho" },
    { id: "TRANSFER", text: "Điều chuyển" },
    { id: "RECALL", text: "Thu hồi" },
    { id: "RETURN", text: "Hoàn trả" }
  ],
  unitDevice: [
    { id: "PIECE", text: "Chiếc" },
    { id: "GEAR", text: "Thùng" }
  ],
  stateDevices: [
    { id: "ACTIVE", text: "Hoạt động" },
    { id: "ERROR", text: "Bị lỗi" },
    { id: "WARRANTY", text: "Đang bảo hành" },
    { id: "LOSS", text: "Thất lạc" },
    { id: "BROKEN_PART", text: "Bị hỏng 1 phần" },
    { id: "BROKEN_ALL", text: "Bị hỏng hoàn toàn" }
  ],
  verifyStatus: [
    { id: "NEW", text: "Mới tạo" },
    { id: "NOT_YET", text: "Mới tạo" },
    { id: "PENDING", text: "Chờ xác thực" },
    { id: "REFUSE", text: "Từ chối" },
    { id: "ACTIVE", text: "Đã xác thực" },
  ],
  contractStatus: [
    { id: "SIGNING", text: "Ký kết" },
    { id: "CANCEL", text: "Đã hủy" },
    { id: "EXPERTISE", text: "Thẩm định" },
    { id: "REJECTED", text: "Từ chối" },
    { id: "SUCCESS", text: "Thành công" },
    { id: "LIQUIDATE", text: "Thanh lý" },
  ],
  receiptStatus: [
    { id: "NEW", text: "Mới tạo" },
    { id: "PENDING_APPROVAL", text: "Chờ duyệt" },
    { id: "WAIT_SETTLEMENT", text: "Chờ kế toán duyệt" },
    { id: "DONE", text: "Đã thu tiền" },
    { id: "CANCEL", text: "Bị huỷ" },
  ],

  localeData: {
    direction: "ltr",
    format: "dd/mm/yyyy",
    separator: " - ",
    applyLabel: "Áp dụng",
    cancelLabel: "Hủy bỏ",
    weekLabel: "W",
    daysOfWeek: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
    monthNames: [
      "Tháng 1",
      "Tháng 2",
      "Tháng 3",
      "Tháng 4",
      "Tháng 5",
      "Tháng 6",
      "Tháng 7",
      "Tháng 8",
      "Tháng 9",
      "Tháng 10",
      "Tháng 11",
      "Tháng 12"
    ],
    firstDay: 0
  },


  statusWarehouseTransfer: [
    { id: "NEW", text: "Mới tạo" },
    { id: "MOVING", text: "Đang chuyển" },
    { id: "REJECT_IMPORT", text: "Từ chối nhập" },
    { id: "SUCCESS", text: "Thành công" },
    { id: "CANCELLED", text: "Đã huỷ" },

    // { id: "COMPLETED", text: "Hoàn thành" },
    // { id: "APPROVED", text: "Đã duyệt" },
    // { id: "REJECTED", text: "Từ chối duyệt" },
    // { id: "NOT_RECEIVED", text: "Không nhận được hàng" }
  ],
  reasonTransferWarehouse: [
    {id:"TRANSFER_PARTNER",text:"Điều chuyển vào kho bank"},
    {id:"TRANSFER_INTERNAL_BANK",text:"Điều chuyển nội bộ kho bank"},
  ],

  satusOderForm: [
    { id: 'NEW', text: 'Mới tạo', bgColor: 'badge-primary' },
    { id: 'CONFIRMED', text: 'CN xác nhận', bgColor: 'badge-warning' },
    { id: 'CANCELED', text: 'Đã huỷ', bgColor: 'badge-danger' },
    { id: 'BRANCH_REJECTED', text: 'CN từ chối', bgColor: 'badge-danger' },
    { id: 'MNP_FULFILLED', text: 'Hoàn thành', bgColor: 'badge-success' },
    { id: 'MNP_REJECTED', text: 'MNP từ chối', bgColor: 'badge-danger' },
    { id: 'MNP_PROCESSING', text: 'MNP đang xử lý', bgColor: 'badge-warning' },
    { id: "TRANSFER_PARTNER", text: "Điều chuyển vào kho bank", bgColor: "badge-info" },
    { id: "TRANSFER_INTERNAL_BANK", text: "Điều chuyển nội bộ kho bank", bgColor: "badge-info" },
  ],

  listStatusMC: [
    {
      id: "NEW",
      text: "Mới tạo"
    },
    {
      id: "POTENTIAL",
      text: "Tiềm năng"
    },
    {
      id: "HAS_CONTRACT",
      text: "Hợp đồng"
    },
    {
      id: "APPROVAL",
      text: "Thẩm định"
    },
    {
      id: "HANDOVER",
      text: "Bàn giao"
    },
    {
      id: "DONE",
      text: "Hoàn thành"
    },
    {
      id: "REJECT",
      text: "Từ chối"
    }
  ],
  digitalSignatureRegistrationStatus: [
    { id: 'PROCESSING', text: 'Đang xử lý', variant: 'primary', bgColor: 'badge-primary' },
    { id: 'COMPLETED', text: 'Hoàn thành', variant: 'secondary', bgColor: 'badge-success' },
    { id: 'REJECTED', text: 'Từ chối', variant: 'warning', bgColor: 'badge-danger' },
  ],
  taxAuthorityVerifyStatus: [
    { id: 'PROCESSING', text: 'Đang xử lý', variant: 'primary', bgColor: 'badge-primary' },
    { id: 'COMPLETED', text: 'Hoàn thành', variant: 'secondary', bgColor: 'badge-success' },
    { id: 'REJECTED', text: 'Từ chối', variant: 'warning', bgColor: 'badge-danger' },
  ],
  optionStatusCombo: [
    { id: '0', text: 'Tất cả', variant: '', bgColor: '' },
    { id: 'NEW', text: 'Mới tạo', variant: 'primary', bgColor: 'badge-primary' },
    { id: 'CANCELED', text: 'Đã hủy', variant: 'secondary', bgColor: 'badge-danger' },
    { id: 'REJECTED', text: 'Từ chối', variant: 'secondary', bgColor: 'badge-danger' },
    { id: 'PENDING', text: 'Chờ xử lý', variant: 'warning', bgColor: 'badge-warning' },
    { id: 'PROCESSING', text: 'Đang xử lý', variant: 'primary', bgColor: 'badge-primary' },
    { id: 'APPROVED', text: 'Đã duyệt', variant: 'success', bgColor: 'badge-success' },
    { id: 'REQUIRED', text: 'Cần bổ sung', variant: 'warning', bgColor: 'badge-warning' },
    { id: 'SUPPLEMENTED', text: 'Đã bổ sung', variant: 'info', bgColor: 'badge-info' }
  ],
  optionPaymentStatusCombo:[
    { id: '0', text: 'Tất cả', variant: '', bgColor: '' },
    { id: 'PAID', text: 'Đã thanh toán', variant: 'success', bgColor: 'badge-success' },
    { id: 'UNPAID', text: 'Chưa thanh toán', variant: 'danger', bgColor: 'badge-danger' }
  ],

  getText: (id, options) => {
    const result = id;
    const finded = options.find((e) => e.id === id);
    if (finded) {
      return finded.text;
    }
    return result;
  },
  getSearch: (data) => {
    return [{ id: '0', text: "Tất cả" }, ...data];
  },

  optionsShippingStatus: [
    { id: 'DELIVERED', text: 'Giao hàng thành công', variant: 'success' },
    { id: 'IN_TRANSIT', text: 'Đang vận chuyển', variant: 'warning' },
    { id: 'FAILED', text: 'Giao hàng thất bại', variant: 'danger' },
  ],
  optionsHandoverType: [
    { id: 'ONLINE', text: 'Online', variant: 'success'},
    { id: 'OFFLINE', text: 'Offline', variant: 'warning'},
  ],
};
